import React from 'react';
import { cn } from './lib/utils';

export function Range({ className = '', ...etc }) {
  return (
    <label
      className={cn(
        'grid auto-cols-auto grid-flow-col items-center justify-start gap-[var(--padding-small)] h-[var(--button-height)]',
        etc.disabled && 'pointer-events-none',
        className,
      )}
    >
      <input
        type='range'
        tabIndex='0'
        className='ui-range'
        {...etc}
      />
    </label>
  );
}
